import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { RecoverySettingsPage } from '@/features/abandoned-checkouts';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/recovery')({
  staticData: { crumb: 'common:nav.recovery', tours: ['settings.recovery'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...storeQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: RecoverySettingsPage,
});
